import { FieldErrorTypes } from '@pages/Onboarding/components/OnboardingFile/OnboardingFile.query';
import { track } from '../utils';

export function importFile(
  Studio: string,
  file: 'spreadsheet' | 'invoice',
  type: string,
  success: boolean,
) {
  track('Onboarding Import File', {
    Studio,
    'File Type': file,
    'MIME Type': type,
    Success: success,
  });
}

export function searchFiles(Studio: string, search: string, results: boolean) {
  track('Onboarding Search Files', {
    Studio,
    'Search Criteria': search,
    'Results found': results,
  });
}

export function closeFile(Studio: string, fileId: string) {
  track('Onboarding Close File', {
    Studio,
    'Onboarding File ID': fileId,
  });
}

export function undoImport(Studio: string, fileId: string) {
  track('Onboarding Undo Import', {
    Studio,
    'Onboarding File ID': fileId,
  });
}

export function searchAssets(Studio: string, search: string, results: boolean) {
  track('Onboarding Search Assets', {
    Studio,
    'Search Criteria': search,
    'Results found': results,
  });
}

export function assetActionsMenu(
  Studio: string,
  fileId: string,
  groupId: string,
  status: string,
) {
  track('Onboarding Asset Actions Menu', {
    Studio,
    'Onboarding File ID': fileId,
    'Onboarding Group ID': groupId,
    'Onboarding Asset Status': status,
  });
}

export function openErrorDialog(
  Studio: string,
  fileId: string,
  groupId: string,
  column: FieldErrorTypes,
) {
  track('Onboarding Open Error Dialog', {
    Studio,
    'Onboarding File ID': fileId,
    'Onboarding Group ID': groupId,
    'Onboarding Field Error Type': column,
  });
}

export function openWarningDialog(
  Studio: string,
  fileId: string,
  groupId: string,
) {
  track('Onboarding Open Warning Dialog', {
    Studio,
    'Onboarding File ID': fileId,
    'Onboarding Group ID': groupId,
  });
}

export function openChat(Studio: string, fileId: string, groupId: string) {
  track('Onboarding Open Chat', {
    Studio,
    'Onboarding File ID': fileId,
    'Onboarding Group ID': groupId,
  });
}
